import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Company Info */}
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <span>© {currentYear} Code D Solution Co., Ltd.</span>
            <span className="hidden sm:inline">•</span>
            <span className="hidden sm:inline">All rights reserved.</span>
          </div>

          {/* License Info */}
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <span>Made with</span>
            <Heart className="h-4 w-4 text-red-500" />
            <span>by Code D Solution Team</span>
          </div>

          {/* Version Info */}
          <div className="text-xs text-gray-400">
            v1.0.0
          </div>
        </div>

        {/* Additional License Text */}
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="text-xs text-gray-500 text-center">
            <p className="mb-2">
              This software is proprietary and confidential. Unauthorized copying, distribution, or modification is strictly prohibited.
            </p>
            <p>
              For licensing inquiries, please contact: <span className="font-medium text-gray-700">admin@codedsolution.io</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
